<template>
  <div>
    <template v-if="state.slots?.top">
      <div class="showTooltips-1">
        <slot name="top"></slot>
      </div>
    </template>
    <template v-else>
      <ul
        v-if="state.value1?.text"
        style="color: var(--el-table-text-color)"
        class="showTooltips-1"
        :style="state.value1.style"
        :title="state.value1?.text"
      >
        {{
          state.value1?.text
        }}
      </ul>
    </template>
    <template v-if="state.slots?.bottom">
      <div
        style="color: #a2a2a2; font-size: var(--tab-group-second-font-size)"
        class="showTooltips-1"
      >
        <slot name="bottom"></slot>
      </div>
    </template>
    <template v-else>
      <ul
        v-if="state.value2?.text"
        style="color: #a2a2a2; font-size: var(--tab-group-second-font-size)"
        class="showTooltips-1"
        :style="state.value2.style"
        :title="state.value2?.text"
      >
        {{
          state.value2?.text
        }}
      </ul>
    </template>
  </div>
</template>

<script>
import { onMounted, reactive, useSlots } from "vue";
export default {
  props: {
    value1: String,
    value2: String,
  },
  setup(props) {
    const state = reactive({
      value1: {
        size: "14px",
        line: 2,
        color: "var(--el-table-text-color)",
      },
      value2: {
        size: "var(--tab-group-second-font-size)",
        color: "#a2a2a2",
      },
    });
    onMounted(() => {
      const value1Type = typeof props.value1;
      if (value1Type !== "object") {
        state.value1.text = props.value1;
      } else {
        state.value1 = props.value1;
      }
      const value2Type = typeof props.value2;
      if (value2Type !== "object") {
        state.value2.text = props.value2;
      } else {
        state.value2 = props.value2;
      }
      state.slots = useSlots();
    });
    return { state };
  },
};
</script>
<style scoped></style>
